import React, { useContext } from "react";

import Checkbox from "components/MultiSelectDropdown/Checkbox";
import { UserContext } from "shared/context/UserContext";
import {
  GetParentCompanyRpidsForGroup,
  IsGroup,
} from "shared/helpers/OrganizationDecomposition";

import "./DecomposeGroupsToggle.css";

/**
 * Header option that lets a GCT user narrow the selected Group down to a subset of the parent
 * companies its member pharmacies belong to. Offered to GCT users only - every other contact type
 * either already sees parent companies as top-level options or has no Groups to decompose.
 *
 * The organization selection itself is unaffected: the Group stays selected either way, and only
 * the separate selectedRpidsForGroup refinement changes.
 */
export default function DecomposeGroupsToggle(props) {
  const userContext = useContext(UserContext);

  if (!userContext.canDecomposeGroups) return null;

  const isEnabled = userContext.isDecomposeGroupsEnabled;

  function onToggle() {
    const nextIsEnabled = !isEnabled;

    // Turning the option on starts from the whole Group, which is what the user was already
    // looking at, so the data on screen does not change until they narrow it themselves. Turning
    // it off clears the narrowing and returns them to the whole Group.
    userContext.onSelectedRpidsForGroupChange(
      nextIsEnabled && IsGroup(userContext.currentOrganization)
        ? GetParentCompanyRpidsForGroup(userContext.currentOrganization)
        : []
    );

    userContext.onDecomposeGroupsEnabledChange(nextIsEnabled);
  }

  return (
    <div
      className="Decompose-Groups-toggle"
      onClick={onToggle}
      role="checkbox"
      aria-checked={isEnabled}
      tabIndex={0}
      onKeyPress={onToggle}
    >
      <Checkbox checked={isEnabled} />
      <span className="Decompose-Groups-toggle--label">
        Enable Parent Company Selection
      </span>
    </div>
  );
}
